/** Same rule as ChannelSettingsForm: data:true = deviceId bound to the channel. */
export function isSmsGateStatusAuthorized(statusResponse: {
    data?: any
    error?: any
} | null): boolean {
    if (!statusResponse || statusResponse.error) return false
    const payload = statusResponse.data
    return payload?.error === false && payload?.data === true
}

export function getSmsGateOnline(statusResponse: {
    data?: any
    error?: any
} | null): boolean | null {
    if (!statusResponse || statusResponse.error) return null
    const online = statusResponse.data?.online
    return typeof online === 'boolean' ? online : null
}

/** Привязка есть и сохранён номер, с которого уходят SMS. Как шаг мастера: номер есть — настраивать больше нечего. */
export function isSmsGateReadyToSend(statusResponse: {
    data?: any
    error?: any
} | null): boolean {
    if (!isSmsGateStatusAuthorized(statusResponse)) return false
    const payload = statusResponse?.data
    return hasSmsSavedNumber({
        phone: payload?.phone,
        simPhones: payload?.simPhones,
    })
}

export function isSmsSavedPhone(value: unknown): boolean {
    return String(value ?? '').replace(/\D/g, '').length >= 10
}

/** Номер канала или любой сохранённый номер SIM. Маска вроде ********6091 не считается. */
export function hasSmsSavedNumber(source?: {
    phone?: unknown
    simPhones?: Record<string, unknown> | null
    extras?: unknown[]
} | null): boolean {
    if (!source) return false
    if (isSmsSavedPhone(source.phone)) return true
    const phones = source.simPhones || {}
    if (Object.keys(phones).some((key) => isSmsSavedPhone(phones[key]))) return true
    return (source.extras || []).some((value) => isSmsSavedPhone(value))
}

/**
 * Общий вход в мастер SMS для сайдбара и мультичата.
 * 0 — установка, 2 — номер SIM (третий шаг), null — номер уже сохранён.
 * null не обрывает уже начатый мастер: права и тест идут после привязки номера.
 */
export function resolveSmsWizardStep(connected: boolean, savedNumber: boolean): 0 | 2 | null {
    if (!connected) return 0
    if (!savedNumber) return 2
    return null
}
